// extracted by mini-css-extract-plugin
export default {"features":"Features_features__gQ0FB","featuresTitle":"Features_featuresTitle__1U+T1","featuresCarousel":"Features_featuresCarousel__CwvdT"};